import {TimelineLite} from "gsap";

export class Car extends PIXI.spine.Spine {
    private readonly _id: number;
    private _hitsLeft: number;

    constructor(id: number, spineData: PIXI.spine.core.SkeletonData,) {
        super(spineData);
        this._id = id;
        this.name = "car_" + this._id;
        this.init();
    }

    public reset(): void {
        this._hitsLeft = 1 + this._id;
    }

    public onHit(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add(() => {
            this._hitsLeft--;
        })
        return tl;
    }

    private init(): void {
        this.name = "car_" + this._id;
    }

    get hitsLeft(): number {
        return this._hitsLeft;
    }

    get id(): number {
        return this._id;
    }
}